"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.YouTubeSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.417 9.127a3.506 3.506 0 0 0-2.476-2.475C24.756 6.066 16 6.066 16 6.066s-8.756 0-10.94.586a3.506 3.506 0 0 0-2.475 2.475C2 11.31 2 15.867 2 15.867s0 4.557.585 6.74a3.506 3.506 0 0 0 2.476 2.475c2.183.585 10.939.585 10.939.585s8.756 0 10.94-.585a3.507 3.507 0 0 0 2.475-2.476c.585-2.182.585-6.74.585-6.74s0-4.556-.585-6.739h.002Zm-16.218 10.94v-8.4l7.275 4.2-7.274 4.2Z" stroke="none"></path>';
var YouTubeSVG = function YouTubeSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.YouTubeSVG = YouTubeSVG;
YouTubeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(YouTubeSVG);
exports.default = _default;